export const deviceStatusName = {
    1: {id: 1, name:'online', color:'#50B48E'},
    2: {id: 2, name:'offline',color:'#DFDFDF'},
    3: {id: 3, name:'error',color:'#FF0000'},
    4: {id: 4, name:'warning',color:'#FFC700'},
    5: {id: 5, name:'charging',color:'#6600FF'},
    6: {id: 6, name:'accident',color:'#FF0000'},
    7: {id: 7, name:'battery low',color:'#FFA500'},
    8: {id: 8, name:'driving',color:'#50B48E'},
    9: {id: 9, name:'parking',color:'#FFC933'},
    10: {id: 10, name:'finishing',color:'#50B48E'},
    11: {id: 11, name:'available',color:'#339EFF'},
    12: {id: 12, name:'maintenance',color:'#FFC700'},
    13: {id: 13, name:'preparing',color:'#FFBF00'},
    14: {id:14, name:'active', color:'#339EFF'},
    15: {id:15, name:'standby', color:'#FFC933'},
    16: {id:16, name:'fail', color:'#FF0000'},
};

export const deviceStatusId = {
        'online': {id: 1, name:'online', color:'#50B48E'},
        'offline': {id: 2, name:'offline',color:'#DFDFDF'},
        'error': {id: 3, name:'error',color:'#FF0000'},
        'warning':  {id: 4, name:'warning',color:'#FFC700'},
        'charging': {id: 5, name:'charging',color:'#6600FF'},
        'accident': {id: 6, name:'accident',color:'#FF0000'},
        'battery low': {id: 7, name:'battery low',color:'#FFA500'},
        'driving': {id: 8, name:'driving',color:'#50B48E'},
        'parking': {id: 9, name:'parking',color:'#FFC933'},
        'finishing': {id: 10, name:'finishing',color:'#50B48E'},
        'available': {id: 11, name:'available',color:'#339EFF'},
        'maintenance': {id: 12, name:'maintenance',color:'#FFC700'},
        'preparing': {id: 13, name:'preparing',color:'#FFBF00'},
        'active': {id:14, name:'active', color:'#339EFF'},
        'standby': {id:15, name:'standby', color:'#FFC933'},
        'fail': {id:16, name:'fail', color:'#FF0000'},
};

